import { render, staticRenderFns } from "./EmailValidation.vue?vue&type=template&id=756a8958&scoped=true"
import script from "./EmailValidation.vue?vue&type=script&lang=js"
export * from "./EmailValidation.vue?vue&type=script&lang=js"
import style0 from "./EmailValidation.vue?vue&type=style&index=0&id=756a8958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a8958",
  null
  
)

export default component.exports